var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内 容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样 式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          ref: "msgForm",
          attrs: {
            model: _vm.itemInfo,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-radio-group",
            {
              on: { change: _vm.updateItem },
              model: {
                value: _vm.itemInfo.msgType,
                callback: function ($$v) {
                  _vm.$set(_vm.itemInfo, "msgType", $$v)
                },
                expression: "itemInfo.msgType",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("小程序客服")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "2" } }, [_vm._v("智能客服")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemInfo.msgType == 2
            ? _c(
                "el-form-item",
                {
                  attrs: { label: "跳转链接：", prop: "msgUrl", required: "" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "链接", min: 0 },
                    on: { blur: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.msgUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "msgUrl", $$v)
                      },
                      expression: "itemInfo.msgUrl",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: { "align-items": "flex-start" },
              },
              [
                _vm.userType === 1
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox",
                            on: {
                              click: function ($event) {
                                return _vm.modalPicTap("1", "bgImg")
                              },
                            },
                          },
                          [
                            _vm.itemInfo.bgImg
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.itemInfo.bgImg, alt: "" },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.itemInfo.bgImg
                          ? _c("i", {
                              staticClass: "el-icon-delete delete-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.removeImg("bgImg")
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader-small",
                            attrs: {
                              action: "",
                              "show-file-list": false,
                              "http-request": function (options) {
                                return _vm.handleLocalUpload(options, "bgImg")
                              },
                              "before-upload": _vm.beforeUpload,
                              accept: ".jpg,.jpeg,.png,image/jpeg,image/png",
                            },
                          },
                          [
                            _vm.itemInfo.bgImg
                              ? _c("img", {
                                  staticClass: "avatar-small",
                                  attrs: { src: _vm.itemInfo.bgImg },
                                })
                              : _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon-small",
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.itemInfo.bgImg
                          ? _c("i", {
                              staticClass: "el-icon-delete delete-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.removeImg("bgImg")
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "upload-tip" }, [
                  _vm._v(
                    "支持 jpg、png、jpeg，大小需小于等于 100KB；有背景图时优先展示图片"
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          !_vm.itemInfo.bgImg
            ? _c(
                "el-form-item",
                { attrs: { label: "图标颜色：" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.iconColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "iconColor", $$v)
                      },
                      expression: "itemInfo.iconColor",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.itemInfo.bgImg
            ? _c(
                "el-form-item",
                { attrs: { label: "文字内容：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入内容", min: 0 },
                    on: { blur: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.textName,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "textName", $$v)
                      },
                      expression: "itemInfo.textName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.itemInfo.bgImg
            ? _c(
                "el-form-item",
                { attrs: { label: "文字颜色：" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.textColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "textColor", $$v)
                      },
                      expression: "itemInfo.textColor",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.itemInfo.bgImg
            ? _c(
                "el-form-item",
                { attrs: { label: "背景颜色：" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.bgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "bgColor", $$v)
                      },
                      expression: "itemInfo.bgColor",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mt", $$v)
                    },
                    expression: "itemInfo.formMargin.mt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mb", $$v)
                    },
                    expression: "itemInfo.formMargin.mb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.ml,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "ml", $$v)
                    },
                    expression: "itemInfo.formMargin.ml",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mr", $$v)
                    },
                    expression: "itemInfo.formMargin.mr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内部间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0, disabled: !!_vm.itemInfo.bgImg },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pt", $$v)
                    },
                    expression: "itemInfo.formPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0, disabled: !!_vm.itemInfo.bgImg },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pb", $$v)
                    },
                    expression: "itemInfo.formPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0, disabled: !!_vm.itemInfo.bgImg },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pl", $$v)
                    },
                    expression: "itemInfo.formPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0, disabled: !!_vm.itemInfo.bgImg },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formPadding, "pr", $$v)
                    },
                    expression: "itemInfo.formPadding.pr",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.itemInfo.bgImg
              ? _c(
                  "div",
                  {
                    staticClass: "upload-tip",
                    staticStyle: { "margin-left": "0" },
                  },
                  [_vm._v("已设置背景图片，内间距不可调整")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "浮动位置：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.positionType,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "positionType", $$v)
                    },
                    expression: "itemInfo.positionType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("左下角")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "2" } }, [_vm._v("右下角")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "3" } }, [_vm._v("左上角")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "4" } }, [_vm._v("右上角")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }